import { colorCSS } from "../../styles";

export const Play = ({ color }: { color?: string }) => {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m5 5h14v14h-14z" />
            <path
                clipRule="evenodd"
                d="m10.0138 16.3878c-.83597.4912-1.5138.105-1.5138-.8645v-7.04491c0-.97008.6755-1.358 1.5138-.86566l6.465 3.79747c.5548.3261.5589.8517 0 1.1801z"
                fill={color ? colorCSS(color) : "currentColor"}
                fillRule="evenodd"
            />
            <circle
                cx="12"
                cy="12"
                r="11.5"
                stroke={color ? colorCSS(color) : "currentColor"}
            />
        </svg>
    );
};
